import { createSelector } from '@reduxjs/toolkit'
import { AppState } from 'store/appState'

export const getAIAgentTyping = createSelector(
  (state: AppState) => state.ai.popup,
  popup => popup.isTyping,
)
